import { TableRow } from 'grommet'
import styled from 'styled-components'

export const HoverTableRow = styled(TableRow)`
  &:hover {
    background-color: ${props => props.theme.global.colors.brand.light};
  }
`
